<template>
  <div class="login-form" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div>
      <div class="d-flex justify-between align-center mb-3 flex-wrap">
        <span class="register-heading" :style="getPrimaryColor">
          Forgot Password
        </span>

        <div class="nav-link text-right">
          Already have an account?&nbsp;
          <router-link to="/signin" class="fw-bold" :style="getPrimaryColor">
            Log In
          </router-link>
        </div>
      </div>

      <div class="divider">
        <span class="line"></span>
        <span class="line"></span>
      </div>
      <div class="content">
        <div>
          <div class="signUp__Flow">
            <div class="mt-4">
              <p class="text-muted opacity-80 fs-7">
                Don't worry if you have forgotten your password. Simply
                provide the email address you used to sign up, and we will
                send you a link to reset it.
              </p>
              <hr />
              <el-form :model="forgotPasswordData" ref="forgotPassword" class="log-form"
                @submit.prevent="submitForm('forgotPassword')">
                <el-form-item label="Email Id*" class="mb-1" prop="email">
                  <el-input type="email" placeholder="Enter email" v-model="forgotPasswordData.email"
                    autocomplete="off"></el-input>
                  <p class="error" v-if="
                    getForgotPasswordErrors && getForgotPasswordErrors.email
                  ">
                    {{ getForgotPasswordErrors.email }}
                  </p>
                </el-form-item>
                <el-form-item class="mt-4">
                  <el-button class="type-2 w-100 fs-6" native-type="submit" @click="submitForm('forgotPassword')"
                    :loading="submitLoading" :style="getButtonStyles" type="primary" size="medium" round>Send Password
                    Reset Email</el-button>
                  <p class="error" v-if="
                    getForgotPasswordErrors &&
                    getForgotPasswordErrors.critical_error
                  ">
                    {{ getForgotPasswordErrors.critical_error }}
                  </p>
                </el-form-item>
              </el-form>
              <p class="mt-3 mt-lg-4" v-if="isSysUserRegistrationEnabled"> Don't have an account ?
                <router-link to="/signup" class="forgot-password-link center-link" :style="getPrimaryColor">
                  SignUp!
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CustomizationLayer from "@/mixins/CustomizationLayer";
export default {
  name: "ForgotPassword",
  data() {
    return {
      submitLoading: false,
      forgotPasswordData: {
        email: "",
        company: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "Email is required",
            trigger: "blur",
          },
        ],
      },
    };
  },

  mixins: [CustomizationLayer],
  mounted() {
    this.$store.dispatch("auth/reset");
  },
  computed: {
    ...mapGetters("auth", [
      "getForgotPasswordStatus",
      "getForgotPasswordErrors",
    ]),
  },
  created() {
    this.$store.commit("errors/setErrors", null, { root: true });
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.forgotPassword();
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    async forgotPassword() {
      try {
        this.submitLoading = true;

        await this.$store.dispatch(
          "auth/forgotPassword",
          this.forgotPasswordData
        );

        if (this.getForgotPasswordStatus) {
          this.$notify.success({
            title: "Success",
            message: `Reset password verification mail send successfully to the ${this.forgotPasswordData.email}`,
          });

          this.$router.push({
            name: "ForgotPasswordVerification",
            query: { email: this.forgotPasswordData.email },
          });
        }
        this.submitLoading = false;
      } catch (err) {
        this.submitLoading = false;
        console.log("forgotPassword", err);
      }
    },
  },
};
</script>


<style lang="scss">
.swal2-icon {
  .swal2-info {
    border-color: #f754a2 !important;
    color: #f754a2 !important;
  }
}

.swal2-styled {
  .swal2-confirm {
    background-color: #f754a2 !important;
  }
}

.has-error {
  border-color: red;
}

a {
  text-decoration: none !important;
  color: #196392 !important;
}

a:hover {
  text-decoration: underline !important;
  /* Optional: underline on hover */
  color: #196392 !important;
}

.divider {
  display: flex;
  align-items: center;
  width: 100%;
  text-align: center;
}

.line {
  flex: 1;
  border-top: 1px solid #ddd;
}



.login-form {
  border: 1px solid #cfcfcf;
  border-radius: 2em;

  width: 100%;
  max-width: 550px;
  padding: 2rem;
  /* border-radius: 8px; */
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.login-form h2 {
  margin-bottom: 1.5rem;
  color: #333;
  text-align: center;
}

.login-form input {
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

@media (max-width: 1024px) {

  .login-form {
    border: 1px solid #cfcfcf;
    border-radius: 2em;
    // max-width: 100%;
    padding: 1.5rem;
    margin: 0 auto;
    box-shadow: none;
  }

  .login-form h2 {
    font-size: 1.5rem;
  }
}

.el-form-item {
  margin-bottom: 8px !important;
}

.d-flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.align-center {
  align-items: center;
}

.flex-wrap {
  flex-wrap: wrap;
}

.mb-3 {
  margin-bottom: 1rem;
}

.m-0 {
  margin: 0;
}

.register-heading {
  font-size: 1.25rem;
  font-weight: 600;
  color: #196392;
  padding-bottom: 0.5rem;
  margin: 0;
  display: inline-block;
}
</style>
